import Accordion from "./Accordion";
import AppBar from "./AppBar";
import Button from "./Button";
import Divider from "./Divider";
import Input from "./Input";
import Switch from "./Switch";
import Tab from "./Tab";
import Tabs from "./Tabs";
import Avatar from "./Avatar";
import Fab from "./Fab";
import Container from "./Container";
import CssBaseline from "./CssBaseline";
import Tooltip from "./Tooltip";
import MenuItem from "./MenuItem";
import List from "./List";
import Dialog from "./Dialog";
import Autocomplete from "./Autocomplete";
import InputLabel from "./InputLabel";
import OutlinedInput from "./OutlinedInput";
import TableContainer from "./TableContainer";
import TableRow from "./TableRow";
import Menu from "./Menu";
import Chip from "./Chip";
import FormControlLabel from "./FormControlLabel ";

export default function ComponentsOverrides(theme) {
  return Object.assign(
    Autocomplete(theme),
    Accordion(theme),
    Button(theme),
    AppBar(theme),
    Divider(theme),
    Switch(theme),
    Tab(theme),
    Tabs(theme),
    Input(theme),
    Avatar(theme),
    Fab(theme),
    Container(theme),
    CssBaseline(theme),
    Tooltip(theme),
    MenuItem(theme),
    Menu(theme),
    List(theme),
    Dialog(theme),
    InputLabel(theme),
    FormControlLabel(theme),
    OutlinedInput(theme),
    TableContainer(theme),
    TableRow(theme),
    Chip(theme)
  );
}
